// @flow
import React from 'react';
import { Container, Row, Col } from 'Components/Grid';
import DealerModel from 'Stores/DealerModel';
import styles from './styles.scss';

import Button from '../../components/Button';

type Props = {
  dealer: DealerModel,
};

class CarsLink extends React.Component<Props> {
  render() {
    const { text, label, href } = this.props.dealer.settings.customTopCars;
    return (
      <Container>
        <Row>
          <Col>
            <div className={styles.configContainer}>
              <div className={styles.configLinkInfo}>{text}</div>
              <Button
                href={href || ''}
                target="_blank"
                trackingLabel="Fahrzeugboerse"
                label={label}
              />
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default CarsLink;
